import EditUserProfileContainer from './EditUserProfile';

export default EditUserProfileContainer;
